import updateLocation from '@logger/sentry/updateLocation';
import { SEARCHED_LOCATION } from '@location/actionTypes';

function updateBySearchedLocation(store, action) {
  updateLocation(action.payload);
}

const locationMiddleware = store => next => action => {
  try {
    switch (action.type) {
      case SEARCHED_LOCATION:
        updateBySearchedLocation(store, action);
        break;
      default:
        break;
    }
    next(action);
  } catch (error) {
    next(action);
  }
};

export default locationMiddleware;
